import React, { useContext } from 'react'
import { Box, useResponsiveWrapperContext } from '@usap/uicomponents'
import { Title } from '@usap/widgets'

import { SearchContext } from '../../common/context/SearchContextProvider'

const filterByPageType = [
  'MakeModelFilterAndDisplay',
  'MakeModelPartFilterAndDisplay',
  'PartFilterAndDisplay',
  'MakePartFilterAndDisplay',
  'YearMakeModelPartFilterAndDisplay',
  'BrandPartFilterAndDisplay',
  'BrandFilterAndDisplay',
]

export default function TopBarHeading() {
  const { isDesktop } = useResponsiveWrapperContext()

  const {
    searchState: { pageTypeId, title },
  } = useContext(SearchContext)

  return (
    <Box id="topBarHeading" margin={{ bottom: 'small' }}>
      {filterByPageType.includes(pageTypeId) ? (
        <Title
          type="h2"
          label={title}
          size={isDesktop ? 'medium' : 'small'}
          style={{
            fontSize: '20px',
          }}
        />
      ) : (
        <Title
          type="h1"
          label={title}
          size={isDesktop ? 'medium' : 'small'}
          style={{
            fontSize: '24px',
          }}
        />
      )}
    </Box>

  )
}
